<template lang="pug">
	.proposal-info
		template(v-if="isLoading")
			.px-loader.loading.flex-row.space
				.loader
					i.fas.fa-circle-notch.fa-spin
				span Loading..
		.widgets-area.segment(v-else)
			.widgets-row
				.widgets-col
					.widgets
						.widget.large
							.header.label Proposal name
							.data-vertical
								DxTextBox(@value-changed="v => data.name = v.value", :value="data.name")
			.widgets-row
				.widgets-col
					.widgets
						.widget
							.header.label Opportunity owner
							.data-vertical
								DxSelectBox(:items="employees", @value-changed="employeeChanged", value-expr="UserId", display-expr="DisplayName", :search-enabled="true", :value="data.opportunityOwnerOid")
						.widget
							.header.label Advertiser
							.data-vertical
								DxDropDownBox(
									ref="advertiserSelect"
									:data-source="companies"
									:value="data.advertiserOid"
									:defer-rendering="false"
									display-expr="Name"
									:show-clear-button="true"
									value-expr="Oid"
									:dropDownOptions="{ minWidth: '400px' }"
									placeholder="Select..."
								)
									template(:#content="{ data }")
										DxDataGrid(
											:data-source="companies"
											:columns=" [{ dataField: 'Name', caption: 'Name', sortOrder: 'asc' }]"
											:hover-state-enabled="true"
											:selected-row-keys="[data.advertiserOid]"
											@selection-changed="v => data.advertiserOid = v.selectedRowKeys[0]"
											height="100%",
											keyExpr="Oid"
										)
											DxSelection(mode="single", :allowSelectAll="false", showCheckBoxesMode="always")
											DxPaging(:enabled="true", :page-size="20")
											DxFilterRow(:visible="true")
											DxScrolling(mode="infinite")
						.widget
							.header.label Advertiser Industry
							.data-vertical
								DxSelectBox(:items="categories", :show-clear-button="true", @value-changed="categoryChanged", value-expr="Code", display-expr="Name", :search-enabled="true", :value="data.advertiserIndustryCode")
						.widget
							.header.label Contact
							.data-vertical
								DxSelectBox(:items="contacts", :show-clear-button="true", :disabled="!contacts.length", @value-changed="contactChanged", value-expr="ContactId", display-expr="Name", :search-enabled="true", :value="data.contactOid")
						.widget
							.header.label Author
							.data-vertical {{data.author}}
				.widgets-col
					.widgets
						.widget
							.header.label Presentation date
							.data-vertical
								DxCalendar(v-model="data.presentationDate")
</template>

<script>
	import VueTypes from 'vue-types';
	import DxButton from 'devextreme-vue/button';
	import DxSelectBox from 'devextreme-vue/select-box';
	import DxTextBox from 'devextreme-vue/text-box';
	import DxCalendar from 'devextreme-vue/calendar';
	import Data from 'app-core/Data';
	import DxDropDownBox from 'devextreme-vue/drop-down-box';
	import { DxDataGrid, DxSelection, DxPaging, DxFilterRow, DxScrolling } from 'devextreme-vue/data-grid';

	export default {
		translationCategory: 'proposal.ProposalInfo',
		name: 'proposal-info',
		components: {
			DxButton,
			DxSelectBox,
			DxTextBox,
			DxCalendar,
			DxDropDownBox, DxDataGrid, DxSelection, DxPaging, DxFilterRow, DxScrolling
		},
		props: {
			data: VueTypes.object.def({}),
			iabCategories: VueTypes.array.def([])
		},
		data() {
			return {
				screen(width) {
					return (width < 900) ? 'xs' : 'lg';
				},
				employees: [],
				companies: [],
				categories: [],
				contacts: []
			};
		},
		computed: {
			isLoading() {
				return !(this.categories.length && this.employees.length && this.companies.length);
			}
		},
		watch: {
			'data.advertiserOid'(v) {
				this.companyChanged(v);
			},
			'isLoading'(v) {
				if (!v && !this.data.name)
					this.data.name = 'New proposal';
			}
		},
		mounted() {
			if (__DEBUG__)
				console.log('Proposal info mounted', this);
			Data.loadCategories().then(r => {
				const parent = r.filter(f => f.Code === '90')[0];
				this.categories = r.filter(f => f.ParentID === parent.UniqueID);
			});
			Data.loadEmployees().then(r => this.employees = r);
			Data.loadCompanies().then(r => this.companies = r);
			if (this.data.advertiserOid)
				this.loadContacts(this.data.advertiserOid);
		},
		methods: {
			employeeChanged(v) {
				this.data.opportunityOwnerOid = v.value;
				this.data.opportunityOwner = this.employees.filter(f => f.UserId === v.value)[0].DisplayName;
			},
			companyChanged(v) {
				if (__DEBUG__)
					console.debug('Company selected', v);
				this.data.contactOid = null;
				var cmp = this.companies.filter(f => f.Oid === v)[0];
				this.data.advertiserName = cmp && cmp.Name;
				if (this.$refs.advertiserSelect && this.$refs.advertiserSelect.instance)
					this.$refs.advertiserSelect.instance.close();
				if (v)
					this.loadContacts(v);
				else
					this.contacts = [];
			},
			categoryChanged(v) {
				this.data.advertiserIndustryCode = v.value;
				this.data.advertiserIndustry = this.categories.filter(f => f.Code === v.value)[0].Name;
			},
			loadContacts(companyId) {
				this.contacts = [];
				Data.getCompany(companyId).then(r => {
					if (__DEBUG__)
						console.info('Company contacts loaded', { r });
					this.contacts = r.Contacts;
					if (this.contacts.length === 1) {
						this.contactChanged({ value: this.contacts[0].ContactId });
					}
				});
			},
			contactChanged(v) {
				const contact = this.contacts.filter(f => f.ContactId === v.value)[0];
				this.data.contactOid = v.value;
				this.data.contactName = contact && contact.Name;
			}
		}
	};
</script>
<style lang='scss'>
	.proposal-info {

	}
</style>
